// Password gate for the admin dashboard.
//
// ⚠️ This is a UI gate, not a security boundary. The database is currently open
// (see “Rules rollout” in CLAUDE.md) and this bundle is public, so anyone
// determined can read survey data directly. It exists to keep the dashboard out
// of students' hands during a session, and it is the piece that becomes real
// once the locked ruleset is deployed. Do not put anything in the survey you
// would not be comfortable being read.
//
// The hash of the current password lives in the database so it can be changed
// from the dashboard without a deploy; DEFAULT_HASH is the fallback.

// sha256('cdm-admin-2028'), change it in the dashboard's Access tab.
export const DEFAULT_HASH = 'e8efde522dff3d94795b756ff3d496d5bfe4f55f3513621f49247caf1ab3f1bd';

const UNLOCK_KEY = 'cdmgrid:adminUnlocked';

export async function sha256Hex(text) {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function verifyPassword(input, storedHash) {
  if (!input) return false;
  const hash = await sha256Hex(input);
  return hash === (storedHash || DEFAULT_HASH);
}

// Unlock lasts for the tab only, closing it re-locks the dashboard.
export const isUnlocked = () => sessionStorage.getItem(UNLOCK_KEY) === '1';
export const setUnlocked = (v) => {
  if (v) sessionStorage.setItem(UNLOCK_KEY, '1');
  else sessionStorage.removeItem(UNLOCK_KEY);
};
